import { SwiperSlide } from 'swiper/react'

import { PostImage, PostVideo } from 'components-ref/molecules'
import type { IFile } from 'types/interfaces/IFile'

interface RenderFileComponentFactoryProps {
    file: IFile
    key: number
    postUserId: string
    allFiles: IFile[]
    handleFileClick: (
        key: number,
        fileType: string
    ) => void
    setVideoCurrentTime?: (seconds: number) => void
    setIsPlaying?: (playing: boolean) => void
    preloadMedia?: boolean
    onOpenOptions?: () => void
    isInViewport?: boolean
    showPreviewVideo: boolean
    isActiveSlide?: boolean
}

const renderFileComponentFactory = ({
    file,
    key,
    postUserId,
    allFiles,
    handleFileClick,
    setVideoCurrentTime,
    setIsPlaying,
    preloadMedia = false,
    onOpenOptions,
    isInViewport = true,
    showPreviewVideo
}: RenderFileComponentFactoryProps) => {
    const hasPortraitMedia = allFiles.some(
        item =>
            item.orientation === 'Portrait'
    )

    if (file?.type === 'photo' || file?.type === 'image') {
        return (
            <SwiperSlide key={key}>
                <PostImage
                    fileIndex={key}
                    file={file}
                    allFiles={allFiles}
                    handleFileClick={() =>
                        handleFileClick(key, 'photo')
                    }
                    preload={preloadMedia}
                    onOpenOptions={onOpenOptions}
                />
            </SwiperSlide>
        )
    }

    if (file?.type === 'video') {
        return (
            <SwiperSlide key={key}>
                <PostVideo
                    segment_data={file.aggregated_segment_data}
                    cloudfront={file.cloudfront}
                    videoDuration={file.duration}
                    thumbnail={file.active_thumb}
                    previewThumbnail={file.preview_thumb}
                    thumbnailGenerating={file.thumbnail_generating}
                    url={file.url}
                    previewVideoUrl={file.preview_video_url}
                    orientation={file.orientation}
                    hasPortraitMedia={hasPortraitMedia}
                    isInViewport={isInViewport}
                    updateSelectedPost={() =>
                        handleFileClick(key, 'video')
                    }
                    videoId={file.id}
                    width={file.width}
                    height={file.height}
                    videoUserId={postUserId}
                    shouldTrackPlayedS
                    onProgressSeconds={setVideoCurrentTime}
                    setIsPlaying={setIsPlaying}
                    onOpenOptions={onOpenOptions}
                    showPreviewVideo={showPreviewVideo}
                />
            </SwiperSlide>
        )
    }

    return <div key={key}>other</div>
}

export { renderFileComponentFactory }